import { createRootRoute, Outlet } from "@tanstack/react-router";

export const Route = createRootRoute({
  component: () => <Outlet />,
  notFoundComponent: () => (
    <main className="flex min-h-screen items-center justify-center px-6">
      <div className="text-center">
        <div className="label-caps">404</div>
        <h1 className="mt-2 text-xl font-semibold">Página não encontrada</h1>
        <a href="/painel" className="mt-4 inline-block text-sm text-emerald hover:underline">
          Ir para o painel
        </a>
      </div>
    </main>
  ),
});
